// src/pages/Property.js
import React from "react";
import { motion } from "framer-motion";
import Property from "../components/Property";


const PropertyPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 50 }}
      transition={{ duration: 0.5 }}
    >
      <Property />
    </motion.div>
  );
};

export default PropertyPage;